<!--设备分配-->
<template>
  <div >
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>
    <a-modal v-model="geoshow"  >
      <MapGeo @mapgeoEvent="SaveMapEvent" :keyWord="address"></MapGeo>
    </a-modal>
<Loading v-show="loadingshow"></Loading>
    <a-card class="all-card-style " >

      <!--分配导航-->
      <a-tabs :default-active-key="currentkey" @change="tabSelect">
        <a-tab-pane key="1">
          <span slot="tab"  class="ant-form-item2 ">
            <a-icon type="switcher" />
            已分配
          </span>
          <a-table :locale="nodata"  @change="handleTableChange" :pagination="pagination" :columns="AllocatedTable.Columns" :data-source="AllocatedTable.Data" v-show="currentkey==1">
            <!-- <span slot="StatusDes" slot-scope="tags">
              <a-tag
                v-for="tag in tags"
                :key="tag"
                :color="tag === 'loser' ? 'volcano' : tag.length > 5 ? 'geekblue' : 'green'"
              >
                {{ tag.toUpperCase() }}
              </a-tag>
            </span> -->
            <span slot="action" slot-scope="text, record">
              <a @click="showAllocatedModal(record,'修改')">修改</a>
              <a-divider type="vertical"/>
              <a @click="CancelAllocated(record)">取消分配</a>
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" force-render>
          <span slot="tab"  class="ant-form-item2 ">
            <a-icon type="file-unknown" />
            未分配
          </span>
          <a-table @change="handleTableChange2" :pagination="pagination2" :columns="UnallocatedTable.Columns" :data-source="UnallocatedTable.Data" v-show="currentkey==2" >
            <span slot="action" slot-scope="text, record">
              <a @click="showAllocatedModal(record,'分配')">分配</a>
            </span>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <!--分配弹出框-->
    <a-modal v-model="AllocatedModalVisible" :title="formtitle" @ok="AllocatedSubmit" @cancel="AllocatedCancel" :maskClosable="false" ok-text="确认" cancel-text="取消">
      <a-form-model ref="deviceData" :rules="FormRules" :model="deviceData" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-model-item  label="设备名称">
          <a-input type="text" autocomplete="off" v-model="deviceData.DeviceName" :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item label="所属产品Key">
          <a-input type="text" autocomplete="off" v-model="deviceData.ProductKey" :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item label="所属产品名称">
          <a-input type="text" autocomplete="off" v-model="deviceData.ProductName" :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item prop="cPlatformID" label="所属项目">
          <a-select v-model="deviceData.cPlatformID" @change="platformSelect">
            <a-select-option v-for="(item,index) in platformSelectItems" :value="item.ID">
              {{item.cPlatformName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="cSceneID" label="所属场地" >
          <a-select v-model="deviceData.cSceneID"  >
            <a-select-option v-for="(item,index) in sceneformSelectItems" :value="item.ID">
              {{item.cSceneName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="DeviceAsName" label="设备别名">
          <a-input type="text" autocomplete="off" v-model="deviceData.DeviceAsName"/>
        </a-form-model-item>
        <a-form-model-item prop="cAddress" label="安装地址">
          <a-input type="text" autocomplete="off" v-model="deviceData.cAddress"/>
          <a @click="toMapPage(deviceData.cAddress)">查询</a>
        </a-form-model-item>
        <a-form-model-item prop="cLongitude" label="经度">
          <a-input type="text" autocomplete="off" v-model="deviceData.cLongitude" />
        </a-form-model-item>
        <a-form-model-item prop="cLatitude" label="纬度">
          <a-input type="text" autocomplete="off" v-model="deviceData.cLatitude" />
        </a-form-model-item>

      </a-form-model>
    </a-modal>
    <!--删除弹出框-->
    <a-modal v-model="deleteModalVisible" title="删除" @ok="handleOk" ok-text="确认" cancel-text="取消">
      <p>是否删除</p>
    </a-modal>


  </div>
</template>

<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'
  import Loading from '@/components/Loading.vue'
  import MapGeo from '@/components/MapGeo.vue'
  import { _getProductData,_getThingModels,_getDevices,_getEntPlatFormData } from '@/common/request.js'

  export default {
    name: 'equipmentAllocationList',
    components: {
      TitleCard,
      Loading,
      MapGeo
    },
    data() {
      return {

        currentkey:"1",
        titleMsg1: "设备管理",
        titleMsg2:'设备分配',
        titleMsg3:'设备分配',
        formtitle:'',
        address:'',
        nodata:{filterConfirm: '确定',
          filterReset: '重置',
          emptyText: ' ',
        },
        geoshow:false,
        pagination: {
          current:1,
          total: 0,
          pageSize: 10,//每页中显示10条数据
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
          showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
        },


        pagination2: {
          current:1,
          total: 0,
          pageSize: 10,//每页中显示10条数据
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
          showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
        },
        queryInfo:{
          productkey:"",
          devicename:"",
          keyword:""

        },
        params:{
          productkey:"",
          devicename:"",
          keyword:"",
          cEntID:'',
          bAllocated:1,
          page:1,
          limit:10
        },
        params2:{
          productkey:"",
          devicename:"",
          keyword:"",
          cEntID:'',
          bAllocated:0,
          page:1,
          limit:10
        },

        okData:[
          {
            key: '1',
            name:'设备一',
            scene:'场地一',
            time:'2020-06-27'
          },
          {
            key: '2',
            name:'设备一',
            scene:'场地一',
            time:'2020-06-27'
          },
          {
            key: '3',
            name:'设备一',
            scene:'场地一',
            time:'2020-06-27'
          },

          {
            key: '4',
            name:'设备一',
            scene:'场地一',
            time:'2020-06-27'
          },

          {
            key: '5',
            name:'设备一',
            scene:'场地一',
            time:'2020-06-27'
          },
        ],
        noData:[
          {
            key: '1',
            name:'设备一',
            time:'2020-06-27'
          },
          {
            key: '2',
            name:'设备一',
            time:'2020-06-27'
          },
          {
            key: '3',
            name:'设备一',
            time:'2020-06-27'
          },

          {
            key: '4',
            name:'设备一',
            time:'2020-06-27'
          },

          {
            key: '5',
            name:'设备一',
            time:'2020-06-27'
          },
        ],
        queryPlatformInfo:{
          cEntID:"",
          keyword:""
        },

        AllocatedTable:{
          Columns:
            [
              {
                title: '设备名称',
                dataIndex: 'DeviceName',
                key: 'DeviceName',
                ellipsis: true,
              },
              {
                title: '设备别名',
                dataIndex: 'DeviceAsName',
                key: 'DeviceAsName',
                ellipsis: true,
              },
              {
                title: '安装地址',
                dataIndex: 'cAddress',
                key: 'cAddress',
                ellipsis: true,
              },
              {
                title: '所属产品Key',
                dataIndex: 'ProductKey',
                key: 'ProductKey',
                ellipsis: true,
              },
              {
                title: '所属产品名称',
                dataIndex: 'ProductName',
                key: 'ProductName',
                ellipsis: true,
              },
              {
                title: '所属项目',
                dataIndex: 'cPlatformName',
                key: 'cPlatformName',
                ellipsis: true,
              },
              {
                title: '所属场地',
                dataIndex: 'cSceneName',
                key: 'cSceneName',
                ellipsis: true,
              },
              {
                title: '设备状态',
                dataIndex: 'StatusDes',
                key: 'StatusDes',
                ellipsis: true,
              },
              // {
              //   title: '设备状态',
              //   key: 'StatusDes',
              //   dataIndex: 'StatusDes',
              //   scopedSlots: { customRender: 'StatusDes' },
              // },
              {
                title: '操作',
                key: 'action',
                scopedSlots: { customRender: 'action' },
              },
            ],
          Data:[]
        },


        UnallocatedTable:{
          Columns:[
            {
              title: '设备名称',
              dataIndex: 'DeviceName',
              key: 'DeviceName',
              //width:200
              ellipsis: true,
            },
            {
              title: '所属产品Key',
              dataIndex: 'ProductKey',
              key: 'ProductKey',
              //width:200
              ellipsis: true,
            },
            {
              title: '所属产品名称',
              dataIndex: 'ProductName',
              key: 'ProductName',
              //width:300
              ellipsis: true,
            },
            {
              title: '设备状态',
              dataIndex: 'StatusDes',
              key: 'StatusDes',
              //width:100
              ellipsis: true,
            },

            {
              title: '操作',
              key: 'action',
              scopedSlots: { customRender: 'action' },
            },
          ],
          Data:[]
        },
        deviceData:{},
        FormRules:{

          cPlatformID:
            [
              { required: true, message: '请选择所属项目', trigger: 'blur' }
            ],
          cSceneID: [
            { required: true, message: '请选择所属场地', trigger: 'blur' }
          ],


          DeviceAsName:[
            { required: true, message: '请输入设备别名', trigger: 'change' }
          ],
          cAddress:[
            { required: true, message: '请输入安装地址', trigger: 'change' }
          ],
          cLongitude:[
            { required: true, message: '请输入经度', trigger: 'change' }
          ],
          cLatitude:[
            { required: true, message: '请输入纬度', trigger: 'change' }
          ]


        },
        platformSelectItem:{},
        platformSelectItems:[],
        sceneformSelectItem:{},
        sceneformSelectItems:[],
        AllocatedModalVisible:false,
        deleteModalVisible:false,
        loadingshow:false
      }
    },
    async created(){

    },
    mounted () {

      let that=this;
      that.params.cEntID=that.$store.getters.User.enterprise.ID;
      that.params2.cEntID=that.$store.getters.User.enterprise.ID;
      that.queryPlatformInfo.cEntID=that.$store.getters.User.enterprise.ID;
      that.getProductData()
      that.getThingModels()
      that.getDevices0()
      that.getDevices1()
      that.getEntPlatFormData()
    },
    methods:{
      handleTableChange(pagination) {

        this.pagination.current = pagination.current;

        this.pagination.pageSize = pagination.pageSize;
        this.params.page = pagination.current;
        this.params.limit = pagination.pageSize;
        this.getDevices0();
      },
      handleTableChange2(pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        this.params2.page = pagination.current;
        this.params2.limit = pagination.pageSize;
        this.getDevices1();
      },
      //查询经纬度
      toMapPage(record){
        let that=this;
        that.address=record;
        that.geoshow=true;


      },
      SaveMapEvent(data){
        let that=this;
        that.deviceData.cLongitude=data.longitude;
        that.deviceData.cLatitude=data.latitude;
        that.geoshow=false;

      },
      tabSelect(key) {
        //console.log(key);
        this.currentkey=key;
      },
      async getProductData(){
        await _getProductData(this,this.queryInfo)
      },
      async getThingModels(){
        var ProductKeys = this.$store.getters.Products.map(item => item.ProductKey).join(",")
        await _getThingModels(this,{productKey:ProductKeys})
      },
      async getDevices0(){

        var _this=this

        const hide = _this.$message.loading('正在获取设备数据请稍候..', 0)
        _this.params.keyword=_this.queryInfo.keyword
        _this.params.productkey=_this.queryInfo.productkey
        _this.params.devicename=_this.queryInfo.devicename
        _this.params.cSystemCode='节水灌溉';
        let res=await _this.$http.post('WLWDevice/PageList',_this.params)

        if(res.data.code ==200){
          setTimeout(hide,100)

          _this.AllocatedTable.Data=res.data.obj.list
          _this.pagination.total=res.data.obj.listTotal


        }
        else{

        }
      },
      async getDevices1(){
        var _this=this

        _this.params2.keyword=_this.queryInfo.keyword
        _this.params2.productkey=_this.queryInfo.productkey
        _this.params2.devicename=_this.queryInfo.devicename
        _this.params2.cSystemCode='节水灌溉';
        let res=await _this.$http.post('WLWDevice/PageList',_this.params2)

        if(res.data.code ==200){

          _this.UnallocatedTable.Data=res.data.obj.list
          _this.pagination2.total=res.data.obj.listTotal

        }
        else{

        }
      },
      /*获取项目列表*/
      async getEntPlatFormData(){
        var that=this
        let res=await  _getEntPlatFormData(this,this.queryPlatformInfo)


        if(res.data.data.code=="200"){

          that.platformSelectItems=res.data.data.obj.list
          if(that.platformSelectItems.length>0) {
            that.deviceData.cPlatformID=that.platformSelectItems[0].ID

            this.getSceneData()
          }
        }

      },
      async getSceneData(){
        var that=this
        let res=await that.$http.post('EntSceneInfo/List',{cSystemCode:'节水灌溉',cPlatformID:that.deviceData.cPlatformID})

        if(res.data.code=="200"){

          that.sceneformSelectItems=res.data.obj.list

          if(that.sceneformSelectItems.length>0) {
            that.deviceData.cSceneID=that.sceneformSelectItems[0].ID

          }
        }

      },
      platformSelect(){

        this.getSceneData()
      },

      showAllocatedModal(record,txt){
        console.log(record)
        let that=this;
        that.formtitle=txt;
        that.AllocatedModalVisible=true
        that.deviceData=record
      },
      AllocatedCancel(){
        this.AllocatedModalVisible=false
      },
      showDeleteModal:function (record) {
        this.deleteModalVisible=true
        that.deviceData.ID=record.ID
      },
      async handleOk () {
        let that=this;
        let res = await that.$http.post('WLWDevice/Delete/'+that.deviceData.ID, null)
        if (res.data.code == "200") {
          this.deleteModalVisible=false
          that.$message.success('删除成功')
          that.getDevices0()

        } else {
          that.$message.error(res.data.message)

        }

      },
      //取消分配
      async CancelAllocated(record){
        let that=this;
        that.deviceData=record;
        that.deviceData.cPlatformID='';

        that.deviceData.cSceneID='';
        that.deviceData.DeviceAsName='';
        that.deviceData.cAddress='';
        that.deviceData.cLatitude='';
        that.deviceData.cLongitude='';

        let res = await that.$http.post('WLWDevice/Save', that.deviceData)
        if (res.data.code == "200") {

          that.$message.success('操作成功')
          that.getDevices0()
          that.getDevices1()
        } else {
          that.$message.error(res.data.message)

        }
      },
      /*分配*/
      AllocatedSubmit(){
        var that = this
        let form=that.$refs['deviceData'];
        form.validate(async valid => {
          if (valid){
            console.log(111,that.sceneformSelectItems);
            that.deviceData.cPlatformName=that.platformSelectItems.find(value=>value.cPlatformID=that.deviceData.cPlatformID).cPlatformName;
            that.deviceData.cSceneName=that.sceneformSelectItems.find(value=>value.cSceneID=that.deviceData.cSceneID).cSceneName;
            console.log(that.deviceData.cPlatformName)
            console.log(that.deviceData.cSceneName)
            let res = await that.$http.post('WLWDevice/Save', that.deviceData)
            if (res.data.code == "200") {
              that.AllocatedModalVisible=false
              that.$message.success('操作成功')
              that.getDevices0()
              that.getDevices1()
            } else {
              that.$message.error(res.message)

            }
          }

        });
      }
    }
  }
</script>

<style>
  .emal-table-box{
    margin-top: 32px;
  }
</style>
